
export const environment = {
  production: false,
  appUrl: 'http://api.smartmatech.com/',
  //appUrl: 'https://localhost:44389/gateway/',
  // G-3PLLH5GTG4    haeaselhodod@gmail.com
  // G-XF9WPDRV1C
  google_trackingId: 'G-3PLLH5GTG4',
  
  RecordPerPage: 8,
  surveyViewName:'view',

  
  

  Entities: {
   
    FormsSurvey:"T09wNlhhNU9CTTA9",
  


  },

  PermissionLevels: {
    Add: "NXhKY1pRRlJBaWs9",
    Edit: "NXhKY1pRRlJBaWs9",
    Delete: "VzNnczNwRmNjSHc9",
    Activate: "OVJrVjFwOWJXa0k9",
    List: "THJFOTBjWHdwL289",
    View: "THJFOTBjWHdwL289",
    Reports: "U2FQVlZlWmJHbUk9"
  },

  EntitiesFrontIdentity: {
  
    FormsSurvey: "FormsSurvey",
  
  },
  counUpSurvay:100,

  tabTitle:{
    Login: {ar:'تسجيل الدخول',en:'Login'},
 
    Surveys:  {ar:'الاستبيانات',en:'Surveys'},
   
  },



 

 




  HijriDateOptions: {
    fullDate: 1,
    year: 2,
    monthYear: 3,
    day: 4
  },


     innerReferance:'THJFOTBjWHdwL289',
     PortalReferance:'THJFOTBjWHdwL289',



  recaptcha: {
   // siteKey: '6Ldg3jImAAAAAH8YZ0bzhvwQ0VKqtzlzOHD_WQRt',

   siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  },

 







};

